import React from 'react';
import I18nWrapper from '../../i18n/i18n-wrapper';
import LoadingDots from './loading-dots';

interface LoadingProps {
  message: string;
  sizeRelativeTo?: string;
}

const Loading: React.FC<LoadingProps> = ({ message, sizeRelativeTo }) => {
  return (
    <div className="w-full max-w-7xl mx-auto px-4 h-full">
      <div
        className={`flex justify-center items-center ${
          !sizeRelativeTo ? 'h-screen' : sizeRelativeTo
        }`}
      >
        <div className="flex flex-col items-center text-center">
          <LoadingDots />
          <p className="mt-3 text-teal font-medium">
            <I18nWrapper translateKey={message} />
          </p>
        </div>
      </div>
    </div>
  );
};

export default Loading;
